<template lang="pug">
  .pdp-playground-modal(v-if="product && product.id" body-scroll-lock-ignore)
    try-it-on(:compare-product-id="product.id" :view-on-model="viewOnModel" @select="changeColor" @cancel="hideModal" data-mr-ass="change-color-modal")

</template>

<script>
  import { mapState, mapActions } from 'vuex';

  export default {
    name: "PdpPlaygroundModal",

    computed: {
      ...mapState('modal', ['modalProps']),
      ...mapState('pdp', ['product']),

      viewOnModel() {
        return this.modalProps.viewOnModel
      }
    },

    methods: {
      ...mapActions('modal', ['hideModal']),

      changeColor(product) {
        this.$root.persistCustomerAnswers({
          last_match_type: 'color_playground',
          want_code: product.code
        }).then(() => {
          this.$router.push('/product/' + product.url_key);
          this.hideModal();
        });
      }
    }
  }
</script>

<style scoped lang="stylus">
  .pdp-playground-modal
    @media mq-mobile
      height 100%
      width 100%
      overflow auto
      
</style>
